// Centralised site configuration — change values here and they propagate everywhere.
export const SITE = {
  brand: "Voltis Électricité",
  tagline: "Électricien certifié — Dépannage & Installation 7j/7",
  phone: "09 72 64 44 40",
  phoneDisplay: "09 72 64 44 40",
  phoneTel: "+33972644440",
  email: "contact@voltis-electricite.fr",
  // No default city — city is detected via IP geolocation (LocationContext)
  defaultRegion: "près de chez vous",
  hours: "Lun – Dim · 7h – 22h · Urgence 24/7",
  yearsExp: 15,
  interventions: 2400,
  emergency: "24/7",
};

export const CITIES = [
  "Paris",
  "Boulogne-Billancourt",
  "Neuilly-sur-Seine",
  "Levallois-Perret",
  "Issy-les-Moulineaux",
  "Vincennes",
  "Saint-Mandé",
  "Montrouge",
  "Clichy",
  "Asnières-sur-Seine",
  "Courbevoie",
  "Suresnes",
  "Puteaux",
  "Nanterre",
  "Saint-Cloud",
  "Rueil-Malmaison",
  "Versailles",
  "Saint-Denis",
];

export const SERVICE_TYPES = [
  "Dépannage électrique",
  "Court-circuit / Disjoncteur",
  "Installation électrique complète",
  "Rénovation électrique",
  "Mise aux normes",
  "Tableau électrique",
  "Recherche de panne",
  "Urgence électrique",
  "Prises & Interrupteurs",
  "Éclairage intérieur / extérieur",
  "Devis / Conseil",
  "Autre",
];

// Brands marquee — logos are handled in the component; we use stylised text rendering.
export const BRANDS = [
  { name: "Legrand", style: "italic", weight: 700 },
  { name: "Schneider Electric", style: "normal", weight: 700 },
  { name: "Hager", style: "normal", weight: 800 },
  { name: "Siemens", style: "normal", weight: 700 },
  { name: "ABB", style: "normal", weight: 800 },
  { name: "Philips", style: "italic", weight: 600 },
  { name: "Atlantic", style: "normal", weight: 700 },
  { name: "Delta Dore", style: "normal", weight: 700 },
  { name: "Eaton", style: "normal", weight: 700 },
  { name: "Niko", style: "normal", weight: 700 },
];

// Photos de réalisations fournies par le client
export const REALISATIONS = [
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/f39u42g8_IMG_2195.jpeg",
    alt: "Tableau électrique Hager — Installation complète maison",
    caption: "Tableau électrique Hager — Installation complète",
    tags: ["Hager", "Tableau électrique", "Installation"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/u8tp8qn1_IMG_2201.jpeg",
    alt: "Tableau Schneider Electric Resi9 avec Wiser EM5 — Maison connectée",
    caption: "Schneider Resi9 + Wiser — Maison connectée",
    tags: ["Schneider", "Domotique", "Rénovation"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/iojrjmqk_IMG_2126.jpeg",
    alt: "Recherche de panne — câblage complexe avec disjoncteur Legrand et Linky",
    caption: "Recherche de panne — Câblage & Linky",
    tags: ["Recherche de panne", "Legrand", "Dépannage"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/b6f7hrih_IMG_2198.jpeg",
    alt: "Tableau électrique Legrand — Cuisine équipée",
    caption: "Tableau Legrand — Circuits cuisine étiquetés",
    tags: ["Legrand", "Cuisine", "Mise aux normes"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/v192hyo3_6e20de2b-65b5-437a-a861-38b4a5539f4d.jpeg",
    alt: "Petit tableau Legrand DX3 avec disjoncteurs DNX3 — Local technique",
    caption: "Tableau Legrand DX3 — Local technique",
    tags: ["Legrand", "DX3", "Local technique"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/hzta42gu_IMG_2200.jpeg",
    alt: "Tableau Legrand double rangée — Appartement",
    caption: "Tableau Legrand 2 rangées — Appartement",
    tags: ["Legrand", "Appartement", "Installation"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/ckexg7fa_91217494-ca61-400e-864f-3541d89542bf.jpeg",
    alt: "Armoire industrielle Hager + Schneider — General Machines",
    caption: "Armoire industrielle — Hager & Schneider",
    tags: ["Hager", "Schneider", "Industriel"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/ieg31qdt_4e805ab6-e2ec-43b7-aeff-e26749fff2f6.jpeg",
    alt: "Armoire Hager — Distribution prises et machines",
    caption: "Armoire Hager — Distribution prises",
    tags: ["Hager", "Distribution", "Pro"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/81cwhqc8_IMG_2196.jpeg",
    alt: "Tableau Hager — Câblage et mise à la terre soignés",
    caption: "Tableau Hager — Câblage & mise à la terre",
    tags: ["Hager", "Câblage", "Norme NF C 15-100"],
  },
  {
    src: "https://customer-assets.emergentagent.com/job_electricien-urgence-1/artifacts/cddh1xxe_IMG_1854.jpeg",
    alt: "Avant rénovation — papier peint floral à retirer pour mise aux normes",
    caption: "Avant rénovation — Préparation chantier",
    tags: ["Rénovation", "Avant/Après", "Préparation"],
  },
];
